import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { useStore } from "../../helpers";
import { classNames } from "../../helpers/utils";
import { LoadingState } from "../../components/LoadingState";
import { StackBarChart } from "../../components/Charts";

export const PrintMediaReportsInsights = observer(() => {
    const { mediaStore } = useStore();
    const { from_date, to_date, lang, sources } = mediaStore.printMediaFilters;

    const [sentimentByDate, setSentimentByDate] = useState([]);
    const [sentimentRawData, setSentimentRawData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const refreshData = async () => {
            setLoading(true);
            await mediaStore.getArticles();
            if (!mediaStore.articles?.insight) {
                setLoading(false);
                return;
            }
            setSentimentByDate(toJS(mediaStore.articles["insight"]["sentiment_by_date"]));
            setSentimentRawData(toJS(mediaStore.articles["insight"]["raw"]));
            setLoading(false);
        };
        void refreshData();
    }, [from_date, to_date, lang, sources, mediaStore]);

    return (
        <div>
            {loading ? <LoadingState /> : null}
            {sentimentRawData.length > 1 ? (
                <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                    <div className="flex flex-col rounded-lg bg-white p-4 font-bold text-purple-500 shadow-lg" style={{ height: 550 }}>
                        <div className="px-4 pb-4 text-2xl">Sentiment by Date</div>
                        <StackBarChart chartId="pm_sentiment_by_date" data={sentimentByDate} type="100%stacked" label="date" />
                    </div>
                    <div className="flex flex-col rounded-lg bg-white p-4 font-bold text-purple-500 shadow-lg" style={{ height: 550 }}>
                        <div className="px-4 pb-4 text-2xl">Sentiment by Source</div>
                        <StackBarChart chartId="pm_sentiment_by_source" data={sentimentByDate} type="100%stacked" label="date" />
                    </div>
                </div>
            ) : null}

            <div className="flex flex-col">
                <div className="mb-5 mt-10 text-2xl font-bold uppercase text-indigo-800">Mentions with Sentiment</div>
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block py-2 align-middle sm:px-6 lg:px-8">
                        <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
                            <table className="divide-y divide-gray-200">
                                <thead className="bg-gray-50 text-center text-xl">
                                    <tr>
                                        <th scope="col" className="px-6 py-3 text-left uppercase tracking-wider">Mention</th>
                                        <th scope="col" className="px-6 py-3 text-left uppercase tracking-wider">Date</th>
                                        <th scope="col" className="px-6 py-3 text-left uppercase tracking-wider">Source</th>
                                        <th scope="col" className="px-6 py-3 text-left uppercase tracking-wider">Sentiment</th>
                                        <th scope="col" className="px-6 py-3 text-left uppercase tracking-wider">Sentiment Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sentimentRawData.map((data, ind) => (
                                        <tr key={`${data.sentence}-${ind}`} className={ind % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                                            <td className="text-md px-6 py-4 font-medium text-gray-900 lg:w-1/2">{data.sentence}</td>
                                            <td className="text-md px-6 py-4">{data.date}</td>
                                            <td className="text-md px-6 py-4">{data.source}</td>
                                            <td className="text-md px-6 py-4">
                                                <span
                                                    className={classNames(
                                                        data.sentiment === "POSITIVE" ? "bg-green-500" : "bg-red-500",
                                                        "text-md inline-flex rounded-full px-2 py-2 font-semibold leading-5 text-white"
                                                    )}
                                                >
                                                    {data.sentiment}
                                                </span>
                                            </td>
                                            <td className="text-md px-6 py-4">{data.sentiment_score}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});
